import { configs, getAuthStandUrl } from 'app/services/AuthService/config';

export const goToRegister = (redirectUrl?: string) => {
  const registerUrl = new URL(
    configs.links.register.replace(':stand', `${getAuthStandUrl()}`),
  );
  const redirectPath = redirectUrl ?? window.location.origin;

  registerUrl.searchParams.append('next', redirectPath);

  window.location.href = registerUrl.href;
};
